'use client';

import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo, useRef } from 'react';
import { questsQueryOptions } from '@/queries/userQuest/userQuest.queries';
import { groupUserQuestsByMissionFrequency } from '../utils/groupUserQuestsByMissionFrequency';

interface UseUserMissionGroupsOptions {
  enabled?: boolean;
}
export const useUserMissionGroups = ({ enabled = true }: UseUserMissionGroupsOptions) => {
  // INFO: For now we have only "daily" missions, and use current date
  // with tomorrow date to avoid duplicate quests for users
  const queryClient = useQueryClient();
  const dateAt = useRef(new Date().toISOString()).current;

  const { data, isPending } = useQuery(questsQueryOptions.userMeQuests({
    filters: {
      startsAt: {
        $lte: dateAt,
      },
      endsAt: {
        $gt: dateAt,
      },
    },
  }, { enabled }));

  const missionGroups = useMemo(() => groupUserQuestsByMissionFrequency(data?.items), [data?.items]);

  const handleExpiredTimer = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: questsQueryOptions.userMeQuests().queryKey });
  }, [queryClient]);

  return {
    isPending,
    missionGroups,
    handleExpiredTimer,
  };
};
